import React from 'react';
import { withRouter } from 'react-router-dom';
import RelEstoqueForm from './RelEstoqueForm.jsx';
import RelEstoqueChart from './RelEstoqueChart.jsx';

class RelatorioEstoque extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            conf: false,
            centros:[],
            centro: "Centro",
            produtos: [],
            produto: "Produto",
            anos: [],
            ano: "Ano",
            verificarPor: "",
            unidade: "",
            baixas: []
        };

        this.changeCentro = this.changeCentro.bind(this);
        this.changeProduto = this.changeProduto.bind(this);
        this.changeAno = this.changeAno.bind(this);
        this.changeVerificarPor = this.changeVerificarPor.bind(this);
        this.voltar = this.voltar.bind(this);
        this.visualizar = this.visualizar.bind(this);
        this.voltarChart = this.voltarChart.bind(this);

    }

    changeCentro(e) {

        let centro = e.target.value
        this.setState({ centro: centro });

        if (centro === "Centro") {

            this.setState({ produtos: [] });
            this.setState({ produto: "Produto" });

        } else {

            fetch("/api/estoque/centro/" + centro, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ produtos: responseJson });

            });

        }

    }

    changeProduto(e) {

        let produto = e.target.value
        this.setState({ produto: produto });

        if (produto === "Produto") {

            this.setState({ anos: [] });
            this.setState({ ano: "Ano" });

        } else {

            fetch("/api/fluxo_estoque/anos/" + produto, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.setState({ anos: responseJson });

            });

        }

    }

    changeAno(e) {
        this.setState({ ano: e.target.value });
    }

    changeVerificarPor(e) {
        this.setState({ verificarPor: e.target.value });
    }

    voltar() {
        this.props.history.push("/relatorios");
    }

    visualizar() {

        this.setState({ disabled: true });

        if (this.state.centro === "Centro") {

            this.props.errMsgHandler("Por favor, informe o centro de custo.");
            this.setState({ disabled: false });

        } else if (this.state.produto === "Produto") {

            this.props.errMsgHandler("Por favor, informe o produto.");
            this.setState({ disabled: false });

        } else if (this.state.ano === "Ano") {

            this.props.errMsgHandler("Por favor, informe o ano das baixas no estoque.");
            this.setState({ disabled: false });

        } else if (this.state.verificarPor === "") {

            this.props.errMsgHandler("Por favor, informe se vai verificar pela Unidade do Produto ou pela Unidade de Medida.");
            this.setState({ disabled: false });

        } else {

            this.props.errMsgHandler("");
            this.props.waitMsgHandler("Aguardando");

            let produto = this.state.produto;
            let ano = this.state.ano;
            let verificarPor = this.state.verificarPor;

            fetch("/api/fluxo_estoque/chart/" + produto + "/" + ano + "/" + verificarPor, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response => response.json())
            .then(responseJson => {

                this.props.waitMsgHandler("");
                this.setState({ unidade: responseJson.unidade });
                this.setState({ baixas: responseJson.baixas });
                this.setState({ conf: true });
                this.setState({ disabled: false });

            });

        }

    }

    voltarChart() {
        this.setState({ conf: false });
        this.setState({ centro: "Centro" });
        this.setState({ produto: "Produto" });
        this.setState({ produtos: [] });
        this.setState({ ano: "Ano" });
        this.setState({ verificarPor: "" });
        this.setState({ anos: [] });
        this.setState({ unidade: "" });
        this.setState({ baixas: [] });
    }

    componentDidMount() {

        if (localStorage.roleRelatorios !== "escrever"
            && localStorage.roleRelatorios !== "ler") {

            window.location.href = "/home";

        }

        fetch("/api/centro/", {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ centros: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="relestoque-title">Relatório de Fluxo de Estoque</h1><br />
                { this.state.conf === false &&
                    <RelEstoqueForm
                        centros={ this.state.centros }
                        centro={ this.state.centro }
                        changeCentro={ this.changeCentro }
                        produtos={ this.state.produtos }
                        produto={ this.state.produto }
                        changeProduto={ this.changeProduto }
                        anos={ this.state.anos }
                        ano={ this.state.ano }
                        changeAno={ this.changeAno }
                        verificarPor={ this.state.verificarPor }
                        changeVerificarPor={ this.changeVerificarPor }
                        voltar={ this.voltar }
                        visualizar={ this.visualizar }
                        disabled={ this.state.disabled } /> }
                { this.state.conf === true &&
                    <RelEstoqueChart
                        centro={ this.state.centro }
                        produto={ this.state.produto }
                        ano={ this.state.ano }
                        unidade={ this.state.unidade }
                        baixas={ this.state.baixas }
                        voltarChart={ this.voltarChart } /> }
            </div>
        );
    }

}

export default withRouter(RelatorioEstoque);

